export const checkRole = (userRoles = [], roles) => {
  if (Array.isArray(roles)) {
    return userRoles.some((role) => roles.includes(role));
  } if (typeof roles === 'string') {
    return userRoles.includes(roles);
  }
  return false;
};
